type Coordinate = {
  lat: number
  lon: number
}

type BoundingBox =
  | {
      topLeft?: Coordinate
      bottomRight?: Coordinate
    }
  | undefined

export const hasBoundingBoxChanged = (
  current: BoundingBox,
  next: BoundingBox
): boolean => {
  const toFixed6 = (num: number): number => Number(num.toFixed(6))

  const corners: (keyof Exclude<BoundingBox, undefined>)[] = [
    'topLeft',
    'bottomRight'
  ]
  const coords: (keyof Coordinate)[] = ['lat', 'lon']

  // Check if both the lat and lon have changed significantly for each corner
  return corners.every(corner => {
    const currentCorner = current?.[corner]
    const nextCorner = next?.[corner]

    if (!currentCorner || !nextCorner) {
      return false
    }
    return coords.every(
      coord => toFixed6(currentCorner[coord]) !== toFixed6(nextCorner[coord])
    )
  })
}
